import { useSelector } from 'react-redux';
import { abTestsStateSelector } from 'store/state/ab-tests/selectors';

export function useABTests() {
  const tests = useSelector(abTestsStateSelector);
  // here maybe defaults will go, i don't know
  return tests;
}
